/**
 * commodities selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import { AppState } from 'services/types';
import get from 'lodash.get';
import { CommoditiesProps, CommoditiesState, CommodityId } from './types';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectCommodities = (state: AppState): CommoditiesState =>
    state.commodities;
const selectCommodityId = (
    state: AppState,
    props: CommoditiesProps
): CommodityId => props.commodityId;

const selectCommoditiesArray = createDeepEqualSelector(
    selectCommodities,
    (commodities) => Object.values(commodities)
);

const selectCommodity = createDeepEqualSelector(
    selectCommodities,
    selectCommodityId,
    (commoditiesState, commodityId) =>
        commodityId && commoditiesState[commodityId]
);

const makeSelectCommodityValue = (field: string): any =>
    createDeepEqualSelector(
        selectCommodity,
        (commodityState) => commodityState && get(commodityState, field)
    );

export {
    selectCommodities,
    selectCommoditiesArray,
    selectCommodityId,
    selectCommodity,
    makeSelectCommodityValue
};
